declare global {
  interface Window {
    __env?: {
      VITE_API_BASE_URL: string;
      VITE_API_PATH_PREFIX: string;
    };
  }
}

const prodBaseUrl = window.__env?.VITE_API_BASE_URL;
const prodPathPrefix = window.__env?.VITE_API_PATH_PREFIX;

const devBaseUrl = import.meta.env.VITE_API_BASE_URL;
const devPathPrefix = import.meta.env.VITE_API_PATH_PREFIX;

const baseUrl = prodBaseUrl || devBaseUrl || "";
const pathPrefix = prodPathPrefix || devPathPrefix || "";

export const API_PREFIX = `${baseUrl}${pathPrefix}`;

/** The API's interactive docs: next to the versioned prefix (prod https://platform.elearning.ae/api/docs). */
export const API_DOCS_URL = `${API_PREFIX.replace(/\/v1\/?$/, '')}/docs`;

/** The Lea engine. Deployed next to the API (helm-chart/templates/lea.yaml in
 *  useradmin), served at <API host>/lea; in dev Vite proxies /lea. */
export const LEA_BASE = `${baseUrl}/lea`;

export const getAbsoluteApiUrl = (path: string): string => {
  // If the path already has a protocol, return it
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Resolve base URL
  let base = window.__env?.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL || "";
  
  if (!base) {
    // Local development fallback: if we are on localhost dev server (port 5173 or any other dev port),
    // the backend runs on port 8000.
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      base = `${window.location.protocol}//${window.location.hostname}:8000`;
    } else {
      base = window.location.origin;
    }
  }
  
  const prefix = window.__env?.VITE_API_PATH_PREFIX || import.meta.env.VITE_API_PATH_PREFIX || "/v1";
  
  // Ensure base doesn't end with slash and prefix starts with slash
  const cleanBase = base.endsWith('/') ? base.slice(0, -1) : base;
  const cleanPrefix = prefix.startsWith('/') ? prefix : `/${prefix}`;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  
  return `${cleanBase}${cleanPrefix}${cleanPath}`;
};